import React from "react";
import { BRAND, whatsappLink } from "../lib/constants";
import { Phone, MapPin, MessageCircle, Mail, Instagram, Facebook } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
    return (
        <footer className="relative bg-coffee-900 text-cream pt-16 pb-8" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-10 border-b border-coffee-700">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3">
                            <Logo size={48} />
                            <div>
                                <div className="font-serif text-xl md:text-2xl leading-none tracking-[0.1em]">VEERAS <span className="italic text-[#B98E4E]">WESTERN GHATS</span></div>
                                <div className="text-[10px] md:text-xs tracking-[0.32em] uppercase text-cream/60 mt-1.5">Resorts &amp; Hospitality</div>
                            </div>
                        </div>
                        <p className="mt-5 text-cream/70 max-w-md text-sm leading-relaxed">
                            A boutique homestay tucked inside a working coffee estate in Sakleshpur.
                            Built around Malnad heritage, a glowing pool, and warm hospitality.
                        </p>
                        <div className="mt-6 flex items-center gap-3">
                            <a href="#" aria-label="Instagram" className="h-10 w-10 rounded-full border border-cream/30 flex items-center justify-center hover:bg-cream hover:text-coffee-900 transition-colors" data-testid="footer-instagram"><Instagram className="h-4 w-4" /></a>
                            <a href="#" aria-label="Facebook" className="h-10 w-10 rounded-full border border-cream/30 flex items-center justify-center hover:bg-cream hover:text-coffee-900 transition-colors" data-testid="footer-facebook"><Facebook className="h-4 w-4" /></a>
                            <a href={whatsappLink()} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="h-10 w-10 rounded-full border border-cream/30 flex items-center justify-center hover:bg-[#25D366] hover:border-[#25D366] transition-colors" data-testid="footer-whatsapp"><MessageCircle className="h-4 w-4" /></a>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-xs tracking-[0.3em] uppercase text-cream/50 mb-4">Visit</div>
                        <ul className="space-y-2 text-sm text-cream/80">
                            <li><a href="#estate" className="hover:text-cream">Coffee Estate</a></li>
                            <li><a href="#pool" className="hover:text-cream">Swimming Pool</a></li>
                            <li><a href="#features" className="hover:text-cream">Experiences</a></li>
                            <li><a href="#rooms" className="hover:text-cream">Rooms</a></li>
                            <li><a href="#events" className="hover:text-cream">Events</a></li>
                            <li><a href="#reviews" className="hover:text-cream">Reviews</a></li>
                            <li><a href="#nearby" className="hover:text-cream">Nearby Places</a></li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="text-xs tracking-[0.3em] uppercase text-cream/50 mb-4">Reach us</div>
                        <ul className="space-y-3 text-sm text-cream/80">
                            <li className="flex items-start gap-3"><MapPin className="h-4 w-4 mt-0.5 shrink-0" /> {BRAND.address}</li>
                            <li className="flex items-center gap-3"><Phone className="h-4 w-4 shrink-0" /> <a href={`tel:${BRAND.phone}`}>{BRAND.phoneIntl}</a></li>
                            <li className="flex items-center gap-3"><Phone className="h-4 w-4 shrink-0" /> <a href={`tel:${BRAND.phone2}`}>{BRAND.phone2Intl}</a></li>
                            <li className="flex items-center gap-3"><Mail className="h-4 w-4 shrink-0" /> <a href={`mailto:${BRAND.email}`}>{BRAND.email}</a></li>
                            <li className="flex items-center gap-3"><MessageCircle className="h-4 w-4 shrink-0" /> <a href={whatsappLink()} target="_blank" rel="noreferrer">Chat on WhatsApp</a></li>
                        </ul>
                    </div>
                </div>

                <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-cream/50">
                    <span>© {new Date().getFullYear()} VEERAS WESTERN GHATS RESORTS &amp; HOSPITALITY. All rights reserved.</span>
                    <span>Crafted with care in the Western Ghats.</span>
                </div>
            </div>
        </footer>
    );
}
